module.exports = __webpack_public_path__ + "static/media/BabyCourse_Mobile_8.84920eaa.jpf";